@if (ref(); as r) {
  <app-file-block-card [ref]="r" [embedded]="true" />
} @else if (metadata(); as m) {
  <div class="px-3 pt-2 pb-2">
    <andypf-json-viewer theme="material-lighter" [data]="m" indent="2" expanded="1" show-toolbar="false" class="json-viewer"></andypf-json-viewer>
  </div>
} @else {
  <div class="px-3 pt-2 pb-2 text-body-secondary mat-font-label-sm">Sin metadata</div>
}
